export default __webpack_public_path__ + "static/media/flag_ja.81aa61af.svg";